export default __webpack_public_path__ + "static/media/Trademark.1224cf51.png";